import { initRelatedProductGalleries } from './related-products-gallery.js';

export const loadRelatedProducts = () => {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.related-products__fetch');

        if (recommendations && recommendations.innerHTML.trim().length) {
          const $recommendationsSection = $(productRecommendationsSection);
          const $recommendationsChildren = $(recommendations).children();
          $recommendationsSection.children().remove();
          $recommendationsSection.append($recommendationsChildren);
          initRelatedProductGalleries();
        }
        return;
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.related-products__fetch');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);
}

(($) => {
  $(() => {
    const $relatedProducts = $('.related-products__fetch');
    if ($relatedProducts.length) {
      setTimeout(() => {
        loadRelatedProducts();
      }, 500);
    }
  })
})(jQuery);
